"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetaContent = void 0;
const getMetaContent = (dom, metaName) => {
    const metaValues = {};
    if (!metaValues[metaName] || dom !== metaValues[metaName].dom) {
        const metatag = dom.querySelector(`meta[name=${metaName}]`);
        metaValues[metaName] = {
            dom,
            value: (metatag === null || metatag === void 0 ? void 0 : metatag.getAttribute('content')) || '',
        };
    }
    return metaValues[metaName].value;
};
exports.getMetaContent = getMetaContent;
//# sourceMappingURL=helper.js.map